import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import RecursiveField2 from "./RecursiveField2.jsx";
import Ajax from './AJAX.jsx';

var tableStyle1 = {
         background: '#F2F2F2',
         padding: 5 
      }
      
var tableStyle2 = Object.assign({},tableStyle1);

tableStyle2.background = '#F8F8F8';

var cellStyle =
{
	padding: '3px 10px 3px 10px',
	maxWidth: "200px",
	overflow:"hidden",
}

var cellStyleClickable = Object.assign({
         cursor: 'pointer', textDecoration: 'underline'},tableStyle1);

class InteractiveTable extends React.Component {
   constructor(props)
   {
   		super(props);
   }

   render() {
    	var rowNames = [];
		if(this.props.rowObjects.length > 0)
		{
			for(var col in this.props.rowObjects[0])
			{
				if(!this.props.hideColumns || this.props.hideColumns.indexOf(col) == -1)
					rowNames.push(col);
			}
		}
      return (
      	<div>
	        <table style={{fontSize:14}}>
	           <tbody>
	              <tr>
	              {rowNames.map((rN,i) => <th key={i} style={cellStyle}>{rN}</th>)}
	              </tr>

	              {this.props.rowObjects.map((rowO, i) => 
	              <InteractiveTableRow key={i} rowData={rowO} lineNr={i} interpreter={this.props.interpreter}
	              clickMap={this.props.clickMap} extraBtns={this.props.extraBtns} styleClick={cellStyleClickable} hideColumns={this.props.hideColumns}/>
	              )}

	           </tbody>
	        {this.props.children}
	        </table>
        </div>
      );
   }
}

class InteractiveTableRow extends React.Component {
	constructor(props)
	{
		super(props);
	}
	render()
	{
		var cols = [];
		for(var col in this.props.rowData)
		{
			if(this.props.hideColumns && this.props.hideColumns.indexOf(col) != -1) {
				continue;
			}

			var clickFunc = (function(colArg) //Create an extra scope to make 'col' var immutable
			{
				var useClickMap = this.props.clickMap && this.props.clickMap[colArg] != null;
				return  !useClickMap ? null :
			(e)=>{this.props.clickMap[colArg](this.props.rowData)}
			}).bind(this)(col);

			cols.push({data:this.props.rowData[col], click:clickFunc, key:col});
		}

		if(this.props.extraBtns != null)
		{
			for(var i = 0; i <this.props.extraBtns.length; i++)
			{
				var func = (eB)=>{
					cols.push({data:eB.name, click:(e) => eB.click(this.props.rowData)});
				}
				func(this.props.extraBtns[i]);
			}
		}
		var style = this.props.lineNr%2== 0 ? tableStyle1 : tableStyle2;

		const interpreter = this.props.interpreter ? this.props.interpreter : {};

		return(
			<tr style={style}>
            {cols.map((r, i) =>{ const interpretedData = interpreter[r.key] ? interpreter[r.key](r.data) : r.data;
            	return <td style={r.click != null ? this.props.styleClick : cellStyle} key={i}
            	onClick={r.click != null ? r.click : null}>
            		{interpretedData !== null && typeof interpretedData === 'object' ?
            		<RecursiveField2 elem={interpretedData}/> : interpretedData}
            	</td>
            })}
            </tr>
			)
	}
}
export default InteractiveTable;


// WEBPACK FOOTER //
// ./js/InteractiveTable.jsx